import { PersonSearchTwoTone } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PermissionKeys, useHasPermission, Widget } from '../../../shared';
import { SearchSupportCaseModal } from '../search-support-case-modal/search-support-case-modal.component';

export const StartRegistrationSearch: FC = () => {
    const { t } = useTranslation();
    const { hasPermission } = useHasPermission();

    const [showSupportCaseSearch, setShowSupportCaseSearch] = useState(false);
    const supportCaseReadPermission = hasPermission(PermissionKeys.SUPPORT_CASES_READ);

    return (
        <>
            <Widget>
                <Stack spacing={2} alignItems="center" justifyContent="center">
                    <PersonSearchTwoTone color="primary" />
                    <Typography variant="h6">{t('searchSupportCase')}</Typography>
                    {t('searchSupportCaseDescription')}
                    <Button
                        data-testid="search-support-case"
                        variant="outlined"
                        size="large"
                        fullWidth
                        onClick={() => setShowSupportCaseSearch(true)}
                        disabled={!supportCaseReadPermission}
                    >
                        {t('search')}
                    </Button>
                </Stack>
            </Widget>
            {supportCaseReadPermission && (
                <SearchSupportCaseModal
                    open={showSupportCaseSearch}
                    handleClose={() => setShowSupportCaseSearch(false)}
                />
            )}
        </>
    );
};
